import { Component, Input } from '@angular/core'

import { SeAvatarType } from './../avatar/avatar-type'

@Component({
  standalone: false,
  selector: 'se-common-avatar',
  host: {'class': 'se-common-avatar'},
  templateUrl: './common-avatar.component.html',
})
export class SeCommonAvatarComponent {

  @Input('se-data-border') border: boolean
  @Input('se-data-type') type: SeAvatarType
  @Input('se-data-size') size: string
  @Input('se-data-identity') identity: string
  @Input('se-data-image-url') imageUrl: string
  @Input('se-data-sport') sport: string
  @Input('se-data-team-color') teamColor: string
  @Input('se-data-status-icon') statusIcon: string
  @Input('se-data-status-color') statusColor: string

  public usePersonaAvatar: boolean = false
  public useTeamAvatar: boolean = false
  public useOrgAvatar: boolean = false
  public hasStatus: boolean = false
  public statusClass: string

  constructor() {
    // noop
  }

  ngOnChanges(): void {
    this.initType()
    this.initStatus()
  }

  public initType(): void {
    this.usePersonaAvatar = this.type === SeAvatarType.Persona
    this.useTeamAvatar = this.type === SeAvatarType.Team
    this.useOrgAvatar = this.type === SeAvatarType.Org
  }

  public initStatus(): void {
    if (this.statusIcon && this.statusColor) {
      this.hasStatus = true
      this.statusClass = `se-common-avatar__status--${this.size} ${this.statusColor}`
    } else {
      this.hasStatus = false
    }

  }

}